import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import FetchModule from "../../Share/Network/FetchModule";
import LocalStorage from "../../Share/Network/LocalStorage";

import PasswordChangeInput from "../../../Component/MySettingPageComponent/PasswordChangeInput";
import { useHistory } from "react-router-dom";
import { useLanguage } from "../../../Context/LanguageContext";

export default function PasswordChangeModal(props) {
  const { onClickExit } = props;

  const history = useHistory();
  const { t } = useLanguage();

  const [nowPassword, setNowPassword] = useState('');
  const [willChangePassword, setWillChangePassword] = useState('');
  const [checkWillChangePassword, setCheckWillChangePassword] = useState('');
  const [isValidPassword, setValidPassword] = useState(false);

  // 화면 스크롤 제어 //
  useEffect(() => {
    document.body.style = `overflow: hidden`;
    return () => document.body.style = `overflow: auto`;
  }, [])

  // 변경하기 클릭시 //
  function onClickSave() {
    if (nowPassword === '') {
      alert(t('myStoreSetting.account.passwordChange.alertCurrentEmpty'));
      return;
    }
    else if (willChangePassword === '') {
      alert(t('myStoreSetting.account.passwordChange.alertNewEmpty'));
      return;
    }
    else if (checkWillChangePassword === '') {
      alert(t('myStoreSetting.account.passwordChange.alertConfirmEmpty'));
      return;
    }
    else if (willChangePassword !== checkWillChangePassword) {
      alert(t('myStoreSetting.account.passwordChange.alertMismatch'));
      return;
    }
    else if (nowPassword === willChangePassword) {
      alert(t('myStoreSetting.account.passwordChange.alertSamePassword'));
      return;
    }
    else if (!isValidPassword) {
      alert(t('myStoreSetting.account.passwordChange.alertFormatError'));
      return;
    }

    const requestData = {
      nowPassword: nowPassword,
      willChangePassword: willChangePassword,
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('account/change/password', 'POST', requestData);

        if (responseData.status === 200) {
          alert(t('myStoreSetting.account.passwordChange.alertSuccess'));

          LocalStorage.clearAll();

          history.push('/');
        }
        else {
          alert(t('myStoreSetting.account.passwordChange.alertCurrentIncorrect'));
          return;
        }
      }
    )();

  }

  function checkPasswordRule(pw) {
    const v = (pw || '').trim();
    const hasLetter = /[a-zA-Z]/.test(v);
    const hasNumber = /[0-9]/.test(v);
    const hasSpecial = /[!@#$%^&*(),.?":{}|<>\-_=+\[\]\\;'`~]/.test(v);
    const hasMinLength = v.length >= 6;

    return hasLetter && hasNumber && hasSpecial && hasMinLength;
  }

  useEffect(() => {
    setValidPassword(checkPasswordRule(willChangePassword));
  }, [willChangePassword]);

  useEffect(() => {
    const okRule = checkPasswordRule(willChangePassword);
    const okMatch =
      willChangePassword.trim() !== '' &&
      willChangePassword === checkWillChangePassword;

    setValidPassword(okRule && okMatch);
  }, [willChangePassword, checkWillChangePassword]);

  return (
    <TopLevelWrapper>
      <Modal>
        <ModalInnerWrapper>
          <TitleWrapper>
            <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#232323' cursor='default'>{t('myStoreSetting.account.passwordChange.title')}</Text>
          </TitleWrapper>
          <InputWrapper marginTop={24}>
            <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#595959' cursor='default'>{t('myStoreSetting.account.passwordChange.currentPassword')}</Text>
            <PasswordChangeInput value={nowPassword} setValue={setNowPassword} placeholder={t('myStoreSetting.account.passwordChange.currentPasswordPlaceholder')}/>
          </InputWrapper>
          <InputWrapper marginTop={12}>
            <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#595959' cursor='default'>{t('myStoreSetting.account.passwordChange.newPassword')}</Text>
            <PasswordChangeInput value={willChangePassword} setValue={setWillChangePassword} placeholder={t('myStoreSetting.account.passwordChange.newPasswordPlaceholder')}/>
          </InputWrapper>
          <InputWrapper marginTop={12}>
            <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#595959' cursor='default'>{t('myStoreSetting.account.passwordChange.confirmNewPassword')}</Text>
            <PasswordChangeInput value={checkWillChangePassword} setValue={setCheckWillChangePassword} placeholder={t('myStoreSetting.account.passwordChange.newPasswordPlaceholder')}/>
          </InputWrapper>
          <ButtonWrapper>
            <ExitButton onClick={onClickExit}>{t('myStoreSetting.account.passwordChange.cancel')}</ExitButton>
            <SaveButton onClick={onClickSave}>{t('myStoreSetting.account.passwordChange.save')}</SaveButton>
          </ButtonWrapper>
        </ModalInnerWrapper>
      </Modal>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100vw;
  height: 100vh;

  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  z-index: 1000;

  background-color: rgba(0, 0, 0, 0.2);
  
  transition: all 0.3s ease-in-out;
`;

const Modal = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 338px;
  height: 374px;

  border-radius: 30px;
  background-color: #FFFFFF;
`;

const ModalInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 83.43%;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: ${props => props.marginTop}px;

  gap: 8px;

  width: 100%;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: flex-end;

  margin-top: 36px;

  gap: 16px;

  width: 100%;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 72px;
  height: 38px;

  border: 1px solid #DFDFDF;
  border-radius: 15px;
  background-color: #FFFFFF;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #CBCBCB;

  &:hover {
    cursor: pointer;
    border: 1px solid #777777;
    color: #777777;
  }
  
  transition: all 0.3s ease-in-out;
`;

const SaveButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 40px;

  border-radius: 15px;
  background-color: #5BD98A;

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #FFFFFF;

  &:hover {
    cursor: pointer;
    background-color: #6DD49E;
  }
  
  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;